import React from "react";
import { HubItemProvider } from "../../components/hubItemProvider/hubItemProvider";
import { ToolDiscount } from "../../components/toolDiscount/toolDiscount";
import "./discount.scss";
import { Col, Row } from "reactstrap";
import bannerBeneficios from "../../assets/imgs/banner-beneficios.jpeg";

export function Discount() {
  return (
      <section className="container-page">
      <Row>
        <Col sm={12}>
          <h2>Beneficios Pride</h2>
        </Col>
        <Col sm={12}>
          <div className="drawer__bg__sections">
            <img
              src={bannerBeneficios}
              alt="Ser parte de la comunidad PrideMx te da estos beneficios"
            />
          </div>
          {/* <div className="discount-header">
                        <div className="discount-header-info">
                            <h4 className="ttls fw600">Ser parte de la comunidad PrideMx te da estos beneficios</h4>
                            <p>Encuentra tus marcas favoritas y sorpréndete </p>
                        </div>
                        <div className="discount-header-thumbnail">
                            <img src={img} alt="" />
                        </div>
                    </div> */}
        </Col>
        <Col sm={12}>
          <ToolDiscount />
        </Col>
        <Col sm={12}>
          <div className="discount-cards">
            <HubItemProvider />
          </div>
        </Col>
      </Row>
    </section>
  );
}
